import { useEffect } from 'react';

import { useDebounceFn } from './useDebounceFn';

export type UseRockBottom = (callback: () => void) => void;
export const useRockBottom: UseRockBottom = (cb) => {
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight) {
        return;
      } else {
        cb();
      }
    };

    const debouncedHandleScroll = useDebounceFn(handleScroll, 500);

    window.addEventListener('scroll', debouncedHandleScroll);
    return () => window.removeEventListener('scroll', debouncedHandleScroll);
  }, [cb]);
};
